import { errorConstants } from "actions/types";
import { includes, omit } from "lodash";

// every *_FAILURE action is produced by ActionCreator.failure(), which wraps
// the payload with wrapError() — declared to return string. The casts below
// apply that contract; reducers see every dispatched action, so the inbound
// field stays unknown.
interface ErrorAction {
  type: string;
  error?: unknown;
  keys?: string[];
}

export const error = (
  state: Record<string, string> = {},
  action: ErrorAction
): Record<string, string> => {
  const { type } = action;
  const matches = /(.*)_(REQUEST|SUCCESS|FAILURE)/.exec(type);

  // remove all error objects from state
  if (type === errorConstants.FLUSH_ERRORS) {
    return {};
  }
  if (type === errorConstants.CLEAR_ERRORS) {
    return omit(state, action.keys ?? []);
  }
  // ignore any action that isn't relevant to api calls being made
  if (!matches) return state;

  const [, requestName, requestState] = matches;
  return {
    ...state,
    // if request action came back as FAILURE we know an error is present, set error, otherwise empty string for error
    [requestName]:
      requestState === "FAILURE" &&
      !includes(action.error as string, "status code 401")
        ? (action.error as string)
        : "",
  };
};
